interface SupportErrorContext {
  traceId: string;
}

export interface SupportQuickTicketPrefill {
  subject: string;
  description: string;
}

let currentBreadcrumbTitle = "";
let quickTicketOpener: ((prefill: SupportQuickTicketPrefill) => void) | null = null;
const openedTraceIds = new Set<string>();

function breadcrumbTitleFromItems(items: any[]): string {
  if (!Array.isArray(items)) {
    return "";
  }

  const titles = items
    .filter(function (item) {
      return item?.type !== "separator" && typeof item?.title === "string";
    })
    .map(function (item) {
      return item.title.trim();
    })
    .filter(Boolean);
  return titles.length > 0 ? titles[titles.length - 1] : "";
}

export function registerCurrentBreadcrumb(items: any[]): void {
  currentBreadcrumbTitle = breadcrumbTitleFromItems(items);
}

export function registerSupportQuickTicketOpener(
  opener: (prefill: SupportQuickTicketPrefill) => void,
): () => void {
  quickTicketOpener = opener;
  return function () {
    if (quickTicketOpener === opener) {
      quickTicketOpener = null;
    }
  };
}

export function openSupportTicketForUnhandledError(context: SupportErrorContext): boolean {
  if (!quickTicketOpener || openedTraceIds.has(context.traceId)) {
    return false;
  }

  const pageTitle = currentBreadcrumbTitle || "صفحه جاری";
  const prefill: SupportQuickTicketPrefill = {
    subject: `خطای غیرمنتظره - ${pageTitle}`,
    description: [
      `هنگام کار با صفحه «${pageTitle}» با خطای غیرمنتظره مواجه شدم.`,
      "",
      `کد پیگیری: ${context.traceId}`,
      `مسیر صفحه: ${window.location.pathname}`,
      "",
      "شرح تکمیلی:",
    ].join("\n"),
  };

  openedTraceIds.add(context.traceId);
  quickTicketOpener(prefill);
  return true;
}
